import {TOGGLE_DARK_MODE} from './../actions/actionTypes';
import {isMobile} from 'react-device-detect';

const initialState ={
    blogs: [
        {"name":"First Blog Post", "component": "FirstBlog", "link": "/first-blog-post", "postDate":"2021-12-27", "keywords": ["general💬"]},
        {"name":"Logstash filters overheads", "component": "Logstash", "link": "/logstash-filter-overheads", "postDate":"2022-01-08", "keywords": ["logstash🪵", "java🙃"]},
        {"name":"Grafana 8.* plugin installation failure", "component": "Grafana", "link": "/grafana-plugin-installation-failure", "postDate":"2022-01-23", "keywords": ["grafana📈"]},
    ],
    darkMode: false,
    isMobileMode: window.innerWidth < 481,
};

const rootReducer = (state=initialState, action) => {
    switch(action.type) {
      case 'TAG_SELECTOR_ACTION':
        return state;
      case 'DECREAMENT':
        return state
      case TOGGLE_DARK_MODE:
        const toggledMode = !state.darkMode
        if (toggledMode) {
          document.body.classList.add("dark-theme");
          document.querySelector('footer').classList.add("dark-theme");

        } else {
          document.body.className = '';
          document.querySelector('footer').classList.remove("dark-theme");
        }
        return {
          ...state,
          darkMode: toggledMode
        }
      default:
        return state;
    }
  }

export default rootReducer;
